
import { createClient } from '@supabase/supabase-js'
import { supabase as integrationSupabase } from '@/integrations/supabase/client'

// We're using the supabase client from the Lovable integration
export const supabase = integrationSupabase
